




import { BrowserMultiFormatReader } from "@zxing/library";
import Vue from "vue";

export default Vue.extend({
  name: "Scanner",
  data() {
    return {
      reader: null as null | BrowserMultiFormatReader,
      device: null as null | MediaDeviceInfo,
    };
  },
  async mounted() {
    this.device = await this.getCamera();
    this.startDecoding();
  },
  methods: {
    startDecoding(): void {
      const deviceID = this.device?.deviceId;
      if (deviceID && this.reader) {
        this.reader.decodeFromVideoDevice(deviceID, "video", (result) => {
          if (result) {
            this.$emit("result", result);
          }
        });
      }
    },
    async getCamera(): Promise<MediaDeviceInfo> {
      this.reader = new BrowserMultiFormatReader();
      let inputDevice: MediaDeviceInfo | null = null;
      const devices = await this.reader.listVideoInputDevices();
      const filteredDevices = devices.filter((device) => {
        device.label.includes("back");
      });
      if (filteredDevices.length > 0) {
        inputDevice = filteredDevices.pop() ?? null;
      } else {
        inputDevice = devices.pop() ?? null;
      }
      if (inputDevice) {
        return inputDevice;
      } else {
        throw new Error("could not find input device");
      }
    },
  },
});
